import { render, staticRenderFns } from "./DashboardSMAZoneChairman.vue?vue&type=template&id=6f2c13e0"
import script from "./DashboardSMAZoneChairman.vue?vue&type=script&lang=js"
export * from "./DashboardSMAZoneChairman.vue?vue&type=script&lang=js"
import style0 from "./DashboardSMAZoneChairman.vue?vue&type=style&index=0&id=6f2c13e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports